import {isDevMode, app, fs, child, process} from "./electron-modules";
import path from 'path';
import slash from "slash";

export const engineMessageTypeJSON = "NODEJSJSONDATA";

class Executable {
  public exePath: string;
  public exeName: string;
  public running: boolean;
  public child;

  constructor(exePath, exeName) {
    this.exePath = exePath;
    this.exeName = exeName;
    this.running = false;
    this.child = null;
  }

  get path() {
    let basePath;
    let appPath = slash(app.getAppPath());
    let executablePath;
    if (!isDevMode) {
      // calculate path using root + folder and name
      basePath = path.dirname(appPath);
      basePath = path.dirname(basePath);
      basePath = path.dirname(basePath);
      executablePath = path.join(basePath, this.exePath, this.exeName);
    } else {
      // grab full path from config file
      const contents = fs.readFileSync(`${appPath}/develop.env`);
      const env = JSON.parse(contents);
      executablePath = env['exe-path'];
    }

    return executablePath;
  }

  statusMessage(message) {
    console.log(`[pid = ${this.child.pid}]: ${message}`);
  }

  run(opts) {
    if (this.running) {
      console.log("Cannot launch multiple instances");
      return;
    }

    const parseLineData = opts.parseLineData !== undefined
      ? opts.parseLineData : true;

    this.running = true;

    let commands = opts.command;
    let exeName = this.exeName;
    let executablePath = this.path;

    // Duplicate the parent's environment object, and add one extra
    let env = process.env;
    let childEnv = {};
    Object.keys(env).forEach(key => {
      childEnv[key] = env[key];
    });

    childEnv['PYTHONUNBUFFERED'] = true;
    childEnv['NODEJS'] = true;

    let cwd = path.dirname(executablePath);

    this.child = child.spawn(executablePath, commands, {
      cwd: cwd,
      env: childEnv
    });

    this.statusMessage(`${exeName} ${commands.join(" ")}`);

    this.child.on('close', () => {
      this.statusMessage(`close`);
      this.running = false;
      this.child = null;

      if (opts.onClose) {
        opts.onClose();
      }
    });

    if (opts.onData) {
      this.child.stderr.on('data', (data) => {
        opts.onData(data);
      });

      this.child.stdout.on('data', (data) => {
        opts.onData(data);
      });
    }

    if (opts.onLine) {
      this.child.stderr.on('data', (data) => {
        this.parseLines(data, opts.onLine, parseLineData);
      });

      this.child.stdout.on('data', (data) => {
        this.parseLines(data, opts.onLine, parseLineData);
      });
    }

    return this.child;
  }

  /** @private */
  parseLines(data, callback, parseLineData) {
    let dataString = data.toString();
    let lines = dataString.split("\n");
    lines.forEach(line => {
      line = line.trim();
      if (line === "") {
        return;
      }

      if (parseLineData) {
        let messageType = line.split(":")[0].trim();
        let messageData = line.split(":").slice(1).join(":").trim();
        callback(messageType, messageData);
      } else {
        callback(line);
      }
    });
  }

  destroy() {
    if (this.running === false) {
      return;
    }

    this.running = false;

    // Kill original process id
    this.statusMessage(`force kill process`);
    process.kill(this.child.pid);

    try {
      let stdout = child.execSync(`wmic process get processid,parentprocessid,executablepath|find "${this.child.pid}"`);
      let lines = stdout.toString().split("\n");

      let subprocessToKill = [];
      lines.forEach(line => {
        line = line.replace(/\s\s+/g, ' ');
        line = line.replace("\n", "");
        if (line.length === 0) {
          return;
        }

        line = line.split(" ");

        let rootProcessID = this.child.pid;
        let parentProcessID = parseInt(line.slice(-3)[0]);
        let processID = parseInt(line.slice(-2)[0]);
        line.splice(-3);

        // Wrong process (wrong parent id)
        if (parentProcessID !== rootProcessID) {
          return;
        }

        // Wrong process (processID == rootProcessID)
        if (processID === rootProcessID) {
          return;
        }

        // Check launch path (engine.exe and known executables)
        let cmdPath = slash(line.join(" "));
        let engineSubprocess = cmdPath.indexOf(this.exeName) !== -1;
        let engineExecutable = cmdPath.indexOf("engine/executables") !== -1;

        if (engineSubprocess || engineExecutable) {
          // Add our sub-process to the list of ones to stop
          subprocessToKill.push(processID);
        }
      });

      // kill all sub-child items
      subprocessToKill.forEach(subprocessID => {
        this.statusMessage(`kill sub-process ${subprocessID}`);
        process.kill(subprocessID);
      });
    } catch (err) {
      console.log(err);
      // Do nothing
    }
  }
}

export class PythonExecutable extends Executable {
  constructor() {
    super("exe-engine", "engine.exe");
    window.onbeforeunload = () => {
      this.destroy();
    };
  }

  write(text) {
    if (!this.running) {
      return;
    }

    this.child.stdin.write(text);
  }
}
